import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { CreditsPage } from './CreditsPage'
import { F0Box } from '@factorialco/f0-react'
import { F0TableOfContent } from '@factorialco/f0-react/dist/experimental'
import i18n from 'modules/core/lib/i18n'
import { MoneyBag } from '@factorialco/f0-react/icons/app'

const RootPage = () => {
  return (
    <ResponsivePage.Body variant="fullscreen">
      <F0Box
        display="flex"
        width="full"
        gap="2xl"
        borderTop="default"
        borderColor="secondary"
        height="full"
      >
        <F0Box
          maxWidth="300px"
          paddingTop="md"
          height="full"
          borderRight="default"
          borderColor="secondary"
        >
          <F0TableOfContent
            activeItem="credits"
            className="h-full"
            items={[
              {
                id: 'credits',
                label: i18n.t('ai.settings.tabs.credits'),
                icon: MoneyBag,
                onClick: () => {},
              },
            ]}
          />
        </F0Box>
        <F0Box width="full" padding="xl">
          <CreditsPage />
        </F0Box>
      </F0Box>
    </ResponsivePage.Body>
  )
}

export default RootPage
